export const selectConsents = state => state.consents;
